<template>
  <div class="m-3">
    <div class="">
      <hr>
      <div class="card-sm-columns card-sm-1-count card-md-2-count card-lg-2-count">
        <div class="card bg-soft-primary mb-3">
          <div class="card-body" style="text-align: left">
            <h3>Representative Example</h3>
            <p class="example-summary">You would like to borrow {{ query.remainingBalance | prettyMoney }} over {{ query.term }} years.</p>
            <div v-if="item.isFixedProduct" class="example-item">
              <div class="example-item-title">Initial term</div>
              <div class="example-item-value">{{ item.initialPeriodDuration }} payments of {{ item.calculations.initialMonthlyCost | prettyMoney }} at {{ item.initialInterestRate | prettyInterestRate }} (fixed)</div>
            </div>
            <div v-if="item.isFixedProduct" class="example-item">
              <div class="example-item-title">Followed by</div>
              <div class="example-item-value">{{ remainingPeriodDuration }} payments of {{ item.calculations.regularMonthlyCost | prettyMoney }} at {{ item.interestRate | prettyInterestRate }} (variable)</div>
            </div>
            <div class="example-item">
              <div class="example-item-title">Total interest</div>
              <div class="example-item-value">{{ totalInterest | prettyMoney }}</div>
            </div>
            <div class="example-item">
              <div class="example-item-title">Total fees</div>
              <div class="example-item-value">{{ totalFees | prettyMoney }}</div>
            </div>
            <div class="example-item">
              <div class="example-item-title">Total amount payable</div>
              <div class="example-item-value">{{ totalAmountPayable | prettyMoney }}</div>
            </div>
          </div>
        </div>
        <div class="card bg-soft-primary mb-3">
          <div class="card-body" style="text-align: left">
            <h3>Savings</h3>
            <div class="fees-container">
              <div class="fees-item">
                <div class="fees-item-title">£ Monthly</div>
                <div class="fees-item-value font-size-2"><MoneySaved :amount="item.calculations.monthlySaving"></MoneySaved></div>
              </div>
              <div class="fees-item">
                <div class="fees-item-title">£ Annual</div>
                <div class="fees-item-value font-size-2"><MoneySaved :amount="item.calculations.annualSaving"/></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card bg-soft-primary mb-3">
          <div class="card-body" style="text-align: left">
            <h3>Fees</h3>
            <div class="fees-container">
              <div class="fees-item">
                <div class="fees-item-title">Valuation</div>
                <div class="fees-item-value">{{ item.fees.valuationFee | prettyMoney }}</div>
              </div>
              <div class="fees-item">
                <div class="fees-item-title">Booking</div>
                <div class="fees-item-value">{{ item.fees.bookingFee | prettyMoney }}</div>
              </div>
              <div class="fees-item">
                <div class="fees-item-title">Arrangement</div>
                <div class="fees-item-value">{{ item.fees.arrangementFee | prettyMoney }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card bg-soft-primary mb-3">
          <div class="card-body" style="text-align: left">
            <h3>Overpayments</h3>
            <p v-if="item.isOverPaymentAllowed">{{ item.overpaymentNote }}</p>
            <p v-else>Overpayments are not permitted.</p>
            <h3 v-if="item.earlyRepaymentCharge">Early Repayment Charge</h3>
            <p v-if="item.earlyRepaymentCharge">
              {{ item.earlyRepaymentChargeNote }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoneySaved from "@/components/products/MoneySaved";
export default {
  name: "ProductCardDetails",
  components: {MoneySaved},
  props: {
    item: Object,
    query: Object
  },
  
  computed: {
    remainingPeriodDuration() {
      return (this.query.term * 12) - this.item.initialPeriodDuration;
    },
    
    totalAmountPayable() {
      return (this.item.initialPeriodDuration * this.item.calculations.initialMonthlyCost)
              + (this.remainingPeriodDuration * this.item.calculations.regularMonthlyCost)    
              + this.totalInterest + this.totalFees;
    },
    
    aprc() {
      let a = this.item.initialPeriodDuration * this.item.initialInterestRate;
      let b = this.remainingPeriodDuration * this.item.interestRate;
      let c = this.query.term * 12;
      
      return (a+b)/c;
    },
    
    totalInterest() {
      return this.query.remainingBalance * (this.aprc / 10);
    },
    
    totalFees() {
      return this.item.fees.arrangementFee + this.item.fees.bookingFee;
    }
  }
}
</script>

<style scoped>
  div.product-card-details {
    column-count: 2 !important;
  }

  @media (max-width: 960px) and (min-width: 501px) {
    div.product-card-details {
      column-count: 1;
    }
  }

  @media (max-width: 500px) {
    div.product-card-details {
      column-count: 1;
    }
  }
  @media (max-width: 960px) {
    div.product-card-details {
      column-count: 1;
    }
  }

  .card-body {
    padding: 1.2rem !important;
  }
  .fees-container {
    display: flex;
  }
  
  .fees-item {
    display: inline-block;
    text-align: center;
    flex: 1 0 auto;
    position: relative;
    align-items: baseline;
    justify-content: space-between;
  }
  
  .fees-item-title {
  }
  
  .fees-item-value {
    font-weight: bold;
  }

  .fees-item:not(:last-child):after {
    border-right: 1px solid #d0d0d0;
    border-bottom: none;
    height: 4rem;
    content: "";
    position: absolute;
    top: 50%;
    left: 100%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
  }

  .example-summary {
    font-weight: bold;
  }

  .example-item {
    display: flex;
    padding-bottom: 1rem;
  }
  .example-item-title {
    flex: 0 0 125px;
  }
  
  .example-item-value {
    font-weight: bold;
    flex: 1 1 250px;
  }
</style>